import { Box, ColorOptions, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useRef, useState } from 'react'
import { TextInput } from 'react-native'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { TextInputWithDelete } from '../../comps/TextInputWithDelete'
import { useStores } from '../../data/store'
import { Colors } from '../../util/util'

export const TxnAttributeComp = ({ setFieldValue, value, updateProductSelection, index }: any) => {
  const [applicableOn, setApplicableOn] = useState<any>(value?.[`txnAttributeKey${index + 1}`] ?? '')
  const [isIncludedId, setIsIncludedId] = useState(value?.[`isIncludedIdChecked${index + 1}`] ?? false)
  const [isExcludedId, setIsExcludedId] = useState(value?.[`isExcludedIdChecked${index + 1}`] ?? false)
  const [condition, setCondition] = useState<string>(isIncludedId ? 'Included' : isExcludedId ? 'Excluded' : 'Select')
  const ref = useRef<TextInput>(null)
  const { ruleConfigErrors, updateRuleConfigError, products } = useStores((store: any) => ({
    updateRuleConfigError: store.campaigns.updateRuleConfigError,
    ruleConfigErrors: store.campaigns.getRuleConfigErrors(),
    count: store.campaigns.getAttributesCount(),
    setAttributesCount: store.campaigns.updateTxnAttributesCount,
    products: store.campaigns.getAllProducts(),
  }))

  const [inputWithDeleteWidth, setInputWithDeleteWidth] = useState(200)
  const handleOnKeyChange = (val: any) => {
    setApplicableOn(val)
    updateProductSelection(val)
    setFieldValue('ruleConfig', { ...value, [`txnAttributeKey${index + 1}`]: val })
    updateRuleConfigError([`txnAttributeKey${index + 1}`], null)
  }

  const handleOnConditionChange = (val: any) => {
    setCondition(val)
    setIsIncludedId(val === 'Included' && val !== 'Excluded')
    setIsExcludedId(val === 'Excluded' && val !== 'Included')
    setFieldValue('ruleConfig', {
      ...value,
      [`isIncludedIdChecked${index + 1}`]: val === 'Included',
      [`isExcludedIdChecked${index + 1}`]: val === 'Excluded',
      [`txnAttributeExcluded${index + 1}`]:
        val === 'Included' ? undefined : value?.[`txnAttributeExcluded${index + 1}`],
      [`txnAttributeIncluded${index + 1}`]:
        val === 'Excluded' ? undefined : value?.[`txnAttributeIncluded${index + 1}`],
    })
  }

  const handleOnIncludedIdChange = (val: any) => {
    setFieldValue('ruleConfig', { ...value, [`txnAttributeIncluded${index + 1}`]: val })
    updateRuleConfigError([`txnAttributeIncluded${index + 1}`], null)
  }

  const handleOnExcludedIdChange = (val: any) => {
    setFieldValue('ruleConfig', { ...value, [`txnAttributeExcluded${index + 1}`]: val })
    updateRuleConfigError([`txnAttributeExcluded${index + 1}`], null)
  }

  const onLayout = ({
    nativeEvent: {
      layout: { width },
    },
  }) => {
    setInputWithDeleteWidth(width)
  }

  const onDeletePress = () => {
    updateProductSelection(applicableOn)
    setFieldValue('ruleConfig', {
      ...value,
      [`txnAttributeKey${index + 1}`]: undefined,
      [`txnAttributeIncluded${index + 1}`]: undefined,
      [`txnAttributeExcluded${index + 1}`]: undefined,
      [`isIncludedIdChecked${index + 1}`]: false,
      [`isExcludedIdChecked${index + 1}`]: false,
    })
    updateRuleConfigError([`txnAttributeKey${index + 1}`], null)
    updateRuleConfigError([`txnAttributeIncluded${index + 1}`], null)
    updateRuleConfigError([`txnAttributeExcluded${index + 1}`], null)
    setApplicableOn(undefined)
  }

  if (applicableOn === undefined) {
    return null
  }

  const getBadgeWidth = () => {
    return inputWithDeleteWidth / 2 - 6
  }
  const handleOnRbChange = (isChecked: any, type: string) => {
    setIsIncludedId(isChecked && type === 'included')
    setIsExcludedId(isChecked && type === 'excluded')
    setFieldValue('ruleConfig', {
      ...value,
      [`isIncludedIdChecked${index + 1}`]: isChecked && type === 'included',
      [`isExcludedIdChecked${index + 1}`]: isChecked && type === 'excluded',
    })
    isChecked &&
      type === 'included' &&
      setFieldValue('ruleConfig', { ...value, [`txnAttributeExcluded${index + 1}`]: undefined })
    isChecked &&
      type === 'excluded' &&
      setFieldValue('ruleConfig', { ...value, [`txnAttributeIncluded${index + 1}`]: undefined })
  }
  return (
    <Box flexDirection={'row'} mb={8}>
      <Box f={0.25}>
        <DropdownOptimised
          label={'Applicable on'}
          placeHolder={isEmpty(applicableOn) ? 'Select' : applicableOn}
          onChange={handleOnKeyChange}
          data={products}
          labelPaddingBottom={8}
          titleColor={Colors.FONT_BLACK as ColorOptions}
          borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
          labelColor={Colors.LABEL_GREY as ColorOptions}
          labelFontFamily={'jiotype-medium'}
          touched
          disabled={!isEmpty(applicableOn)}
          disabledBg={'WHITE'}
          error={ruleConfigErrors[`txnAttributeKey${index + 1}`]}
        />
      </Box>
      <Box f={0.37} marginLeft={16}>
        <DropdownOptimised
          label={'Condition'}
          labelPaddingBottom={8}
          labelColor={Colors.LABEL_GREY as ColorOptions}
          borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
          titleColor={Colors.FONT_GREY as ColorOptions}
          chevronColor={'BLACK_75'}
          labelFontFamily={'jiotype-medium'}
          placeHolder={condition ?? 'Condition'}
          onChange={handleOnConditionChange}
          touched={true}
          data={[
            { id: '1', value: 'Included' },
            { id: '2', value: 'Excluded' },
          ]}
        />
      </Box>
      <Box f={0.37} marginTop={6} marginLeft={16} onLayout={onLayout} marginBottom={6}>
        <TextInputWithDelete
          label={isIncludedId ? "Included Id's" : "Excluded Id's"}
          title={isIncludedId ? "Included Id's *" : "Excluded Id's *"}
          {...styles.textinputStyle}
          badgeWidth={getBadgeWidth()}
          value={
            isIncludedId ? value?.[`txnAttributeIncluded${index + 1}`] : value?.[`txnAttributeExcluded${index + 1}`]
          }
          fieldName={isIncludedId ? `txnAttributeIncluded${index + 1}` : `txnAttributeExcluded${index + 1}`}
          onChangeText={isIncludedId ? handleOnIncludedIdChange : handleOnExcludedIdChange}
          editable={!!applicableOn && (isExcludedId || isIncludedId)}
          error={
            isIncludedId
              ? ruleConfigErrors?.[`txnAttributeIncluded${index + 1}`]
              : ruleConfigErrors?.[`txnAttributeExcluded${index + 1}`]
          }
          touched
          setFieldValue={isIncludedId ? handleOnIncludedIdChange : handleOnExcludedIdChange}
          setValuesOnFieldNameObject={true}
          bgColor={Colors.BG_BLUE_LIGHT as ColorOptions}
          color={Colors.BG_BLUE as ColorOptions}
          textWidth={72}
          isProducts={true}
          hideDelete={false}
          innerRef={ref}
        />
      </Box>
      <Box
        onPress={onDeletePress}
        testID="delete-txn-attr"
        underlayColor="TRANSPARENT"
        p={8}
        marginLeft={8}
        h={30}
        w={30}
        align={'center'}
        borderRadius={4}
        marginTop={24}
        bg={Colors.BG_BLUE_LIGHT as ColorOptions}>
        <Text title={'-'} color={Colors.BG_BLUE as ColorOptions} fontFamily={'jiotype-bold'} />
      </Box>
    </Box>
  )
}

const styles = {
  textinputStyle: {
    type: 'body12',
    labelPaddingBottom: 8,
    borderRadius: 40,
    fontFamily: 'jiotype-medium',
    labelFontSize: 12,
    fontSize: 12,
    selectionColor: 'BLUE',
    paddingHorizontal: 8,
    color: 'BLACK_21',
    labelFontFamily: 'jiotype-medium',
    labelColor: Colors.LABEL_GREY as ColorOptions,
    borderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
    focusBorderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
    placeholderTextColor: Colors.LABEL_GREY as ColorOptions,
  } as any,
}
